module.exports = __webpack_public_path__ + "static/media/change-password-banner.e93d4635.png";